import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import FNOLPAWizard from './FNOLPAWizard';
import FNOLPACollisionDetailsPage from './pages/Details/Collision/CollisionDetailsPage';
import FNOLPAGlassDetailsPage from './pages/Details/Glass/GlassDetailsPage';
import FNOLPATheftDetailsPage from './pages/Details/Theft/TheftDetailsPage';
import FNOLPARepairFacilityPage from './pages/RepairFacility/RepairFacilityPage';
import FNOLPARepairFacilityMapPage from './pages/RepairFacilityMap/RepairFacilityMapPage';
import FNOLPATypeOfIncidentPage from './pages/TypeOfIncident/TypeOfIncidentPage';
import FNOLPATypeOfRepairPage from './pages/TypeOfRepair/TypeOfRepairPage';
import FNOLPAVehiclesPage from './pages/Vehicles/VehiclesPage';

setComponentMapOverrides(
    {
        FNOLPAWizard: { component: 'FNOLPAWizard' },
        FNOLPATypeOfIncidentPage: { component: 'FNOLPATypeOfIncidentPage' },
        FNOLPAVehiclesPage: { component: 'FNOLPAVehiclesPage' },
        FNOLPATypeOfRepairPage: { component: 'FNOLPATypeOfRepairPage' },
        FNOLPARepairFacilityPage: { component: 'FNOLPARepairFacilityPage' },
        FNOLPACollisionDetailsPage: { component: 'FNOLPACollisionDetailsPage' },
        FNOLPAGlassDetailsPage: { component: 'FNOLPAGlassDetailsPage' },
        FNOLPATheftDetailsPage: { component: 'FNOLPATheftDetailsPage' },
        FNOLPARepairFacilityMapPage: {
            component: 'FNOLPARepairFacilityMapPage',
        },
    },
    {
        FNOLPAWizard,
        FNOLPATypeOfIncidentPage,
        FNOLPAVehiclesPage,
        FNOLPATypeOfRepairPage,
        FNOLPARepairFacilityPage,
        FNOLPACollisionDetailsPage,
        FNOLPAGlassDetailsPage,
        FNOLPATheftDetailsPage,
        FNOLPARepairFacilityMapPage,
    }
);

export { FNOLPAWizard as default };
